import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services';
import { useQuery } from '@tanstack/react-query';
import { RolesApiAdapter } from '../adapters/RolesApiAdapter';
import { RolePermission } from '../models/Roles';

/**
 * Hook para obtener la lista de permisos disponibles desde la API
 * @returns Objeto con permisos, estado de carga y error
 */
export const usePermissionsList = () => {
  const httpClient = createHttpClient(apiClientWH);
  const apiAdapter = new RolesApiAdapter(httpClient);

  const {
    data: permissions = [],
    isLoading,
    error,
    refetch,
    isFetching,
    isPending,
  } = useQuery({
    queryKey: ['permissions'],
    queryFn: () => apiAdapter.getPermissions(),
    staleTime: 10 * 60 * 1000, // 10 minutos - los permisos no cambian frecuentemente
    refetchOnWindowFocus: false,
  });

  return {
    permissions: permissions as RolePermission[],
    isLoading: isLoading || isPending,
    error,
    refetch,
    isFetching,
  };
};


